var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lv-base-column',_vm._b({ref:"column",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var rowIndex = ref.rowIndex;
var col = ref.col;
var colIndex = ref.colIndex;
var editRow = ref.editRow;
var fixedRow = ref.fixedRow;
return [_c('link-table-column-radio-item',_vm._b({attrs:{"row":row,"disabled":_vm.disabled,"edit-row":editRow,"row-index":rowIndex,"col":col,"col-index":colIndex,"fixed-row":fixedRow,"true-label":_vm.trueLabel,"false-label":_vm.falseLabel,"scope-slot-func":_vm.$scopedSlots.default},on:{"change":_vm.setDefault,"click":_vm.lv_clickItem}},'link-table-column-radio-item',_vm.columnItemBinding,false))]}}])},'lv-base-column',_vm.columnBinding,false))}
var staticRenderFns = []

export { render, staticRenderFns }